@if (isFetched || leadReport.length) {
  <div class="flex flex-col gap-3">
    <!-- Caption -->
    <div class="flex items-center justify-between">
      <h3 class="font-semibold text-4">
        {{ translatePrefix + 'report' | translate }} {{ leadReportDate | date: 'MM/dd/yyyy HH:mm' }}
      </h3>

      <div *ngxPermissionsOnly="Permission.REPORT_EXPORT">
        <app-button
          (onClick)="exportMenu.toggle($event)"
          label="Export"
          size="sm"
          icon="icon-wl-upload"
          iconPosition="left"
          [isDropdown]="true"
          [loading]="isExporting"
          variant="outline-secondary"></app-button>
        <p-menu #exportMenu [model]="exportOptions" [popup]="true">
          <ng-template pTemplate="item" let-item>
            <div class="flex items-center gap-2 p-2 cursor-pointer">
              <img class="w-5 h-5" [src]="item.img" [alt]="item.title" />
              <span>{{ item.title }}</span>
            </div>
          </ng-template>
        </p-menu>
      </div>
    </div>

    <p-table
      [value]="leadReport"
      [scrollable]="true"
      (onSort)="onSort($event)"
      [lazy]="true"
      [customSort]="true"
      [loading]="isLoading">
      <ng-template pTemplate="header">
        <tr class="truncate">
          <th
            pFrozenColumn
            [frozen]="true"
            alignFrozen="left"
            frozenColStyle="left"
            [pSortableColumn]="LEAD_EXPORT_TO_SORT_FIELD[LeadExportFieldEnum.USER]!">
            <div class="flex items-center">
              <div class="w-12">{{ 'report.no.' | translate }}</div>
              @if (isUserColumnIncluded) {
                <div>
                  <app-sort-table-header
                    [field]="LEAD_EXPORT_TO_SORT_FIELD[LeadExportFieldEnum.USER]!"
                    [label]="translatePrefix + 'user' | translate"
                    [sortField]="sortField"
                    [sortOrder]="sortOrder"></app-sort-table-header>
                </div>
              }
            </div>
          </th>

          @for (col of visibleColumns; track $index) {
            @if (col.key !== LeadExportFieldEnum.USER) {
              <th class="!text-right" [pSortableColumn]="LEAD_EXPORT_TO_SORT_FIELD[col.key]!">
                <app-sort-table-header
                  [field]="LEAD_EXPORT_TO_SORT_FIELD[col.key]!"
                  [label]="translatePrefix + col.labelKey | translate"
                  [sortField]="sortField"
                  [sortOrder]="sortOrder"></app-sort-table-header>
              </th>
            }
          }
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-item let-i="rowIndex">
        <tr class="truncate">
          <!-- No. -->
          <td pFrozenColumn [frozen]="true" alignFrozen="left" frozenColStyle="left">
            <div class="flex items-center">
              <div class="w-12">
                {{ i + 1 + (pagination?.page ?? 0) * (pagination?.size ?? 10) }}
              </div>
              @if (isUserColumnIncluded) {
                <div>{{ item.fullName }}</div>
              }
            </div>
          </td>
          @for (col of visibleColumns; track $index) {
            @switch(col.key) {
              @case (LeadExportFieldEnum.TOTAL_LEADS_MOVED) {
                <!-- Total lead moved -->
                <td class="!text-left">{{ item.leadMoved }}</td>
              }
              @case (LeadExportFieldEnum.TOTAL_LEADS_TAKE_CARE) {
                <!-- Total leads take care -->
                <td class="!text-left">{{ item.leadTakeCare }}</td>
              }
              @case (LeadExportFieldEnum.TOTAL_LEADS_CREATED) {
                <!-- Total leads created -->
                <td class="!text-left">{{ item.leadCreated }}</td>
              }
              @case (LeadExportFieldEnum.CUSTOMER) {
                <!-- Customer -->
                <td class="!text-left">{{ item.customer }}</td>
              }
              @case (LeadExportFieldEnum.PROSPECT) {
                <!-- Prospect -->
                <td class="!text-left">{{ item.prospect }}</td>
              }
              @case (LeadExportFieldEnum.HIDDEN) {
                <!-- Hidden -->
                <td class="!text-left">{{ item.hidden }}</td>
              }
            }
          }
        </tr>
      </ng-template>

      <ng-template pTemplate="emptymessage">
        <tr>
          <td [colSpan]="20">
            <app-empty-table></app-empty-table>
          </td>
        </tr>
      </ng-template>
    </p-table>

    <app-custom-paginator
      [(pagination)]="pagination"
      [totalRecords]="totalReports"
      [options]="options"
      (onChange)="onPagination()"></app-custom-paginator>
  </div>
}
